import Money from 'common/components/layout/Money';

const SalePrice = (props) => {
  const { product, settings } = props;
  if (!product.variants) {
    return null;
  }
  const variant = product.variants[0];
  const price = variant.comparePrice || variant.price;
  if (!variant) {
    return null;
  }
  if (!variant.addToCartPrice) {
    return null;
  }
  if (variant.addToCartPrice >= price) {
    return null;
  }
  return (
    <div className="c7-product__variant__price__sale">
      {variant.actionMessage}{' '}
      <Money number={variant.addToCartPrice} settings={settings} />
    </div>
  );
};

export default SalePrice;
